import React, { Component } from 'react';

//componentes
import MensualidadGM from './mensualidadGM'

class Index extends Component {

    render(){
        return(
            <div>
                <MensualidadGM />
            </div>
        );
    }

}
export default Index;